import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';
import makeStyles from '@mui/styles/makeStyles';

const CustomTooltip = ({ children, tooltipStyles, ...props }) => {
  const useStyles = makeStyles(theme => ({
    arrow: {
      color: theme.palette.custom.white,
    },
    tooltip: {
      backgroundColor: theme.palette.custom.white,
      color: theme.palette.custom.black,
      fontSize: 12,
      fontWeight: 500,
      borderRadius: 3,
      padding: '10px 12px',
      boxShadow: '-2px 3px 4px 1px rgba(155, 155, 155, 0.3)',
      ...tooltipStyles,
    },
  }));

  return (
    <Tooltip classes={useStyles()} {...props}>
      {children}
    </Tooltip>
  );
};

CustomTooltip.defaultProps = {
  tooltipStyles: {},
};

CustomTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.number]).isRequired,
  tooltipStyles: PropTypes.object,
};

export default CustomTooltip;
